import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleDate from "../../../../../modules/SimpleDate";
import Button from "../../../../../modules/commons/Button";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import moment from "moment";

class ReceivingUnitDGISearch extends Component {
  getDataValue(fieldName) {
    return !R.isNil(this.props.state.searchData) && this.props.state.searchData[fieldName]
      ? moment(this.props.state.searchData[fieldName]).format('DD-MM-YYYY')
      : null;
  }

  render() {
    return (
      <FlexView
        style={{ justifyContent: "space-between" }}
        vAlignContent="center"
        className="margin-top-5px"
      >
        <form onSubmit={this.props.onSubmit}>
          <FlexView vAlignContent="center" style={{ gap: "10px" }}>
            <SimpleDDL
              id="select_options_nama_cabang"
              box="search"
              name="kodeCabang"
              containerclassname="width width-250px"
              placeholder="Nama cabang hak akses"
              options={this.props.state.cabangOptions}
              value={this.props.state.kodeCabang}
              onChange={(value, { name }) => this.props.onCabangChange(name, value)}
            />
            <p className="margin-left-25px margin-bottom-20px">Periode</p>
            <SimpleDate
              id="select_date_startDateSL"
              name="startDateSL"
              nextdate
              date={this.getDataValue("startDateSL")}
              maxDate={this.getDataValue("endDateSL")}
              onChange={(value) => this.props.onValueChange("startDateSL", value)}
            />
            <SimpleDate
              id="select_date_endDateSL"
              name="endDateSL"
              nextdate
              date={this.getDataValue("endDateSL")}
              onChange={(value) => this.props.onValueChange("endDateSL", value)}
            />
            <SimpleButton type="submit" className="margin-bottom-20px">
              Cari
            </SimpleButton>
          </FlexView>
        </form>
        <Button
          type="button"
          onClick={this.props.onShowFilter}
          className="btn background-red margin-bottom-20px"
        >
          <span>
            <i className="fa fa-qrcode"></i>
          </span>
        </Button>
      </FlexView>
    );
  }
}

export default ReceivingUnitDGISearch;
